import {createActions} from 'redux-arc';
import {GET} from './types';

const foodApiBase = 'food/';

export const {types, creators: foodCreators} = createActions('food', {
  read: {url: `${foodApiBase}:id/`, method: GET},
  list: {url: foodApiBase, method: GET}
});
